import { Dialog } from '@headlessui/react'
import { useSnapshot } from 'valtio'
import React, { type ReactElement } from 'react'
import { startOfTomorrow } from 'date-fns'
import dateFnsFormat from 'date-fns/format'
import cn from 'classnames'
import { recurringPaymentProxy } from '../../../../../shared/proxies/recurringPaymentProxy'
import PlayIcon from '../../../../../shared/components/ui/icons/PlayIcon'
import { StandardDateInput } from '../../../../../shared/components/ui/forms/StandardDateInput'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import { executeRecurringTransactionResume } from './executeRecurringTransactionResume'

export function ConfirmResumeModal (): ReactElement | null {
  const { displayResumeModal, recurringPayment, nextPaymentDate } = useSnapshot(recurringPaymentProxy)
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)

  const formattedTomorrow = dateFnsFormat(startOfTomorrow(), 'yyyy-MM-dd')

  const maxDate = recurringPayment?.endDate ?? undefined

  if (recurringPayment == null) {
    return null
  }

  return (
    <Dialog
      open={displayResumeModal}
      onClose={() => { recurringPaymentProxy.displayResumeModal = false }}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="relative bg-white rounded max-w-xl mx-auto p-5">
          <Dialog.Title>
            <div className="mb-4">
              <div className="text-2xl font-medium text-center">Select the Next Occurrence Date Before Resuming</div>

            </div>
          </Dialog.Title>

          <div className="text-center text-gray-700 text-lg mb-2">
            The next charge will run on the date selected below and then continue &nbsp;
            <span className="font-semibold">
              {recurringPayment?.billingCycle}
            </span>
          </div>

          <StandardDateInput
            minDate={formattedTomorrow}
            maxDate={maxDate}
            label="Next Occurrence Date"
            value={nextPaymentDate ? nextPaymentDate.toLocaleString() : ''}
            onChange={(e) => {
              recurringPaymentProxy.nextPaymentDate = e.target.value
            }}
            onBlur={(e) => {
              recurringPaymentProxy.nextPaymentDate = e.target.value
            }}
          />

          <div className="mt-6 flex flex-row justify-center">
            <button
              className="rounded bg-wpy-alert-red-600 border-red-700 px-4 mx-4 py-2 text-white hover:bg-red-300"
              onClick={() => {
                recurringPaymentProxy.nextPaymentDate = null
                recurringPaymentProxy.displayResumeModal = false
              }}
            >
              Cancel
            </button>

            <button
              disabled={!recurringPaymentProxy.nextPaymentDate}
              className={cn(buttonColors.classes, 'disabled:bg-gray-200 flex items-center justify-center rounded px-4 mx-4 py-2 text-white ')}
              onClick={executeRecurringTransactionResume}
            >
              <span className=" mr-2">
                <PlayIcon color="#FFF" />
              </span>
              Select and Resume
            </button>
          </div>
        </div>
      </div>

    </Dialog>
  )
}
